import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { useState } from 'react';
import { ANALYTIC_FEATURES, RoutePath, USER_ROLE, USER_ENHANCED_ROLE } from 'constants/app.constant';
import { APP_LINK_PAGE_NAME_WITH_ROUTE } from 'constants/externalApp.constant';
import { appActions, appSelectors } from 'redux/ducks/app';
import { checkPathMatch } from 'helpers/app.helper';
import { trackAAFeature } from 'services/adobe-analytics.service';
import { PerformancePath } from 'reports/cw/constants/cw.constant';
import { PS_PATHS } from 'reports/ps/constants';
import { SH_PATHS } from 'reports/sh/constants/sh.constant';
import { shSelectors } from 'reports/sh/redux/ducks/sh';
import { DP_PATHS } from 'reports/dp/constants/dp.constant';
import useDemoUser from 'reports/dp/hooks/useDemoUser';
import useMapEaqTopicToHesiExamByCourseId from '../../../hooks/ui/useMapEaqTopicToHesiExamByCourseId';
var useBentoBoxModal = function (_a) {
    var handleCourseSelectionModal = _a.handleCourseSelectionModal, isHesiReadinessApp = _a.isHesiReadinessApp, courses = _a.courses, onClickOutSide = _a.onClickOutSide;
    var history = useHistory();
    var dispatch = useDispatch();
    var _b = useState(false), isEHRModalShowing = _b[0], setEHRModalShowing = _b[1];
    var isCWBentoBoxLinkShow = useSelector(appSelectors.getIsCWBentoBoxLinkShow);
    var isCWBentoBoxLinkLoading = useSelector(appSelectors.getIsCWBentoBoxLinkLoading);
    var appLinkOutPostBody = useSelector(appSelectors.getAppLinkOutPostBody);
    var isEhrReportingEnabled = useSelector(appSelectors.getIsEhrReportingEnabled);
    var isNclexReportingEnabled = useSelector(appSelectors.getIsNclexReportingEnabled);
    var isShEnabled = useSelector(appSelectors.getIsShEnabled);
    var eaqTopicMappedHesiExamByISBN = useSelector(appSelectors.getEaqTopicMappedHesiExamByISBN);
    var allSHCourses = useSelector(shSelectors.getCourses);
    var userRole = useSelector(appSelectors.getUserRole);
    var userEnhancedRole = useSelector(appSelectors.getUserEnhancedRoles);
    var courseSectionsByReport = useMapEaqTopicToHesiExamByCourseId({ courses: courses, eaqTopicMappedHesiExamByISBN: eaqTopicMappedHesiExamByISBN, isEHRModalShowing: isEHRModalShowing });
    var isDemoUser = useDemoUser();
    var isDeanEnhancedRole = userEnhancedRole === null || userEnhancedRole === void 0 ? void 0 : userEnhancedRole.includes(USER_ENHANCED_ROLE.DEAN);
    var isDeanBentoEnabled = isDeanEnhancedRole && userRole === USER_ROLE.EOLS_INSTRUCTOR;
    var isEHRDisable = !isEhrReportingEnabled;
    var isHADDisable = !isNclexReportingEnabled;
    var isCWDisable = !isCWBentoBoxLinkShow;
    var isPRDDisable = !isShEnabled;
    var isDPDisable = !isDeanBentoEnabled && !isDemoUser;
    var onCWNavigation = function () {
        trackAAFeature(ANALYTIC_FEATURES.BENTO_BOX_CW_LINK_CLICK);
        if (checkPathMatch([PerformancePath.courseAggregate])) {
            window.location.reload();
            return;
        }
        history.push(PerformancePath.courseAggregate);
    };
    var onEHRNavigation = function () {
        trackAAFeature(ANALYTIC_FEATURES.BENTO_BOX_EHR_LINK_CLICK);
        setEHRModalShowing(true);
        handleCourseSelectionModal();
    };
    var onHADNavigation = function () {
        trackAAFeature(ANALYTIC_FEATURES.BENTO_BOX_HAD_LINK_CLICK);
        if (checkPathMatch([RoutePath.had])) {
            window.location.reload();
            return;
        }
        var path = RoutePath.had;
        if (!isHADDisable) {
            history.push(path);
        }
    };
    var onPRDNavigation = function () {
        trackAAFeature(ANALYTIC_FEATURES.BENTO_BOX_PRD_LINK_CLICK);
        var courseAggregate = SH_PATHS.courseAggregate, dashboard = SH_PATHS.dashboard;
        var path = allSHCourses.length > 1 ? courseAggregate : dashboard;
        if (checkPathMatch([path])) {
            onClickOutSide();
            return;
        }
        if (!isPRDDisable) {
            history.push(path);
        }
    };
    var onPSNavigation = function () {
        trackAAFeature(ANALYTIC_FEATURES.BENTO_BOX_PS_LINK_CLICK);
        var path = PS_PATHS.homePage;
        history.push(path);
    };
    var onDPNavigation = function () {
        trackAAFeature(ANALYTIC_FEATURES.BENTO_BOX_DP_LINK_CLICK);
        var path = DP_PATHS.welcome;
        if (!isDPDisable) {
            history.push(path);
        }
    };
    var handleRedirectPage = function () {
        var performanceReportPage = (appLinkOutPostBody || {}).performanceReportPage;
        if (performanceReportPage !== APP_LINK_PAGE_NAME_WITH_ROUTE.PERFORMANCE_HESI_READINESS.name) {
            dispatch(appActions.setIsCWSubNavInEHRPageShow(true));
        }
        if (isHesiReadinessApp) {
            history.push(RoutePath.ehr);
        }
        history.push(RoutePath.ehr);
    };
    var onCloseCourseSelectionModal = function () {
        handleCourseSelectionModal();
        setEHRModalShowing(false);
    };
    return {
        isCWDisable: isCWDisable,
        isEHRDisable: isEHRDisable,
        isHADDisable: isHADDisable,
        isPRDDisable: isPRDDisable,
        isDPDisable: isDPDisable,
        onEHRNavigation: onEHRNavigation,
        onHADNavigation: onHADNavigation,
        onCWNavigation: onCWNavigation,
        onPRDNavigation: onPRDNavigation,
        onDPNavigation: onDPNavigation,
        handleRedirectPage: handleRedirectPage,
        isCWBentoBoxLinkLoading: isCWBentoBoxLinkLoading,
        isEHRModalShowing: isEHRModalShowing,
        courseSectionsByReport: courseSectionsByReport,
        onCloseCourseSelectionModal: onCloseCourseSelectionModal,
        onPSNavigation: onPSNavigation
    };
};
export default useBentoBoxModal;
